'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.betausers.list', [])
  .controller('BetaUsersListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/betausers/list/index.js